if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super()
        this.button = this.querySelector('button')
        this.atcButton = document.querySelector('#addtocart')
        this.init()
      }
      init() {
        this.button ? this.button.addEventListener('click', this.clickATCButton.bind(this)) : null
        document.addEventListener('scroll', this.checkToActivateSticky.bind(this));
        this.buildSizeSelector()
      }
      checkToActivateSticky(e){
        let buttonBottom = this.atcButton.getBoundingClientRect().bottom
        let buttonHeight = this.atcButton.getBoundingClientRect().height
        if(buttonBottom <= 0 && buttonHeight != 0){
          !this.classList.contains('active') ? this.classList.add('active') : null
        }else {
          this.classList.contains('active') ? this.classList.remove('active') : null
        }
      }
      clickATCButton(e) {
        this.atcButton ? this.atcButton.click() : null
      }
      buildSizeSelector(e) {
        let sizeContainer = document.querySelector('[data-product-size]')
        if(sizeContainer) {
          let selectContainer = document.createElement('select')
          selectContainer.setAttribute('id', "sticky-atc__select")
          let sizeOptions = sizeContainer.querySelectorAll('[data-product-option]')
          sizeOptions.forEach((option, index) => {
            let newOption = document.createElement('option')
            newOption.setAttribute('class', 'sticky-atc__option')
            if(option.hasAttribute('data-value')){
              let value = option.getAttribute('data-value')
              newOption.setAttribute('value', value)
              newOption.innerText = value
            }
            selectContainer.append(newOption)
          })

          selectContainer.addEventListener('change', this.clickActiveSize.bind(this))
          let buttonSelectWrapper = this.querySelector('.sticky-atc__button-select-wrapper')
          buttonSelectWrapper.prepend(selectContainer)
        }
      }
      clickActiveSize(e) {
        let value = e.currentTarget.value
        let variantSelector = document.querySelector(`[data-product-option][data-value="${value}"]`)
        if(variantSelector){
          variantSelector.click()
        }
      }
    }
  )
}